import { EllipseConfig } from '@ahha/stableComponents/Canvas/types/theme'

export const DEFAULT_THEME_CONFIG = {
  ellipse: {
    stroke: '#7785FF',
    strokeWidth: 3,
    fill: '#FFF',
    dash: undefined,
    opacity: 1,
  },
  transformer: {
    anchor: {
      size: 6,
      stroke: '#FFF',
      strokeWidth: 2,
      cornerRadius: 0,
      fill: '#FFF',
    },
    border: {
      stroke: '#FFF',
      strokeWidth: 0,
      dash: undefined,
      rotateAnchorOffset: 20,
    },
  },
} satisfies EllipseConfig

export const MIN_POSITION = {
  x: 0.1,
  y: 0.1,
}

export const MIN_ELLIPSE_SIZE = 5

export const COMPUTATIONAL_ERROR = -0.01

export const CIRCLE_SNAPSHOT_ID = 'CIRCLE'
